module.exports = __webpack_public_path__ + "static/media/flag.c620c8db.svg";